import { Component, inject } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  authService = inject(AuthService);

  appVersion = environment.appVersion;

  currentYear = new Date().getFullYear();

  isAuthenticated$ = this.authService.isAuthenticated$;
}
